module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-sleepy.bc573116.png";